import React from 'react';
import '../styles/components.css';
import StockIndicator from './StockIndicator';

const ProductCard = ({ product, highlight }) => {
    // Support pour les APIs Zoho et Odoo
    const { 
        image,         // Odoo
        image_name,    // Zoho
        name, 
        default_code,  // Odoo
        sku,           // Zoho
        qty_available, // Odoo
        stock_on_hand, // Zoho
        custom_field_hash // Zoho custom fields
    } = product;

    // Utilise l'image appropriée selon l'API (Zoho ou Odoo)
    const productImage = image || (image_name ? `/api/zoho/item/${product.item_id}/image` : null);

    // Utilise le SKU approprié selon l'API (Zoho ou Odoo)
    const productSku = sku || default_code;
    // Utilise le stock approprié selon l'API (Zoho ou Odoo)
    const stockLevel = stock_on_hand !== undefined ? stock_on_hand : qty_available;
    
    // Vérifier si le produit est en production (custom field cf_in_production_1)
    // Utiliser la même logique que pour les MOQ : accès direct aux propriétés
    const etaValue = product.cf_in_production_1 || 
                    custom_field_hash?.cf_in_production_1 || '';
    
    const isInProduction = etaValue && etaValue !== '';

    // Vérifier si le produit est discontinué (custom field cf_tbd)
    const isDiscontinuedValue = product.cf_tbd || 
                               custom_field_hash?.cf_tbd || false;
    
    const isProductDiscontinued = isDiscontinuedValue === true || isDiscontinuedValue === 'true';

    return (
        <div className={`product-card client-card${highlight ? ' highlight' : ''}`}>
            <div className="product-image-container">
                <img src={productImage || '/images/placeholder.png'} alt={name} />
            </div>
            
            <div className="product-info">
                <p className="product-reference">SKU: {productSku || 'N/A'}</p>
                <h3 className="product-name">{name}</h3>
                
                <StockIndicator stockLevel={stockLevel} etaValue={etaValue} />
                
                {/* Badge ETA de production - placé après l'indicateur de stock */}
                {isInProduction && (
                    <div className="production-indicator">
                        <span className="production-badge">{etaValue}</span>
                    </div>
                )}
                
                {/* Badge discontinued item - placé après l'indicateur ETA */}
                {isProductDiscontinued && (
                    <div className="discontinued-indicator">
                        <span className="discontinued-badge">UNTIL STOCK LAST</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProductCard;